import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as styles from './styles.css';

export default function WeekCell({ weekNumber, selected, onClick }) {
  const weekClasses = classNames('btn btn-circle', {
    [styles.weekCellButton]: !selected,
    [styles.weekCellButtonSelected]: selected,
  });

  return (
    <td>
      <button
        data-testid="weekCellButton"
        className={weekClasses}
        onClick={onClick}
        type="button"
      >
        {weekNumber}
      </button>
    </td>
  );
}

WeekCell.propTypes = {
  weekNumber: PropTypes.number.isRequired,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
